import React, { useEffect, useRef, useState } from "react";
import { ENDPOINTS } from "../../../js/api/_config";
import axios from "axios";

const ImageUploader = ({
  setSelectedImage,
  setUploadStatus,
  setIsLoading,
  setFileUploadNum,
  index,
  updateHandleImageChange,
  removeImage,
  setRemoveImage,
  imgurl
}) => {
  const [previewUrl, setPreviewUrl] = useState(imgurl);
  const [fileName, setFileName] = useState(""); // Store the file name
  const fileInputRef = useRef(null); // Reference to the file input element
  const [currImg, setCurrImg] = useState();

  const handleUploadSubmit = async (file) => {
    if (!file) return;
    setIsLoading(true);
    setUploadStatus("");

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        ENDPOINTS.TRIALS.UPLOAD_IMAGE,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        setFileUploadNum({ newImageId: response.data.data, index });
        if(response.data.data){
          updateHandleImageChange(index,"trialIntroductionNewImage",response.data.data,file)
          
        }
        
        setUploadStatus("Image uploaded successfully!");
      } else {
        setUploadStatus("Failed to upload the image.");
      }
    } catch (error) {
      setUploadStatus("An error occurred while uploading.");
    } finally {
      setIsLoading(false);
    }
  };


  const handleImageChange = (event) => {
    const file = event.target.files[0];
   
    if (file) {
      setSelectedImage(file); // Store the actual file for uploading
      setPreviewUrl(URL.createObjectURL(file)); // Generate and set the preview URL
      setFileName(file.name);
      handleUploadSubmit(file)
    }
  
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
    setUploadStatus("");
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl); // Revoke the object URL to free memory
      setPreviewUrl(null);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Reset the file input value
    }
    setFileName(""); // Clear the file name
    updateHandleImageChange(index,"trialIntroductionNewImage",null,null)
  };

  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger the file input's click event
    }
  };

  useEffect(()=>{
    if(removeImage){
      handleRemoveImage();
      setRemoveImage(false)
    }
  },[removeImage])

  useEffect(() => {
    // Cleanup preview URL on component unmount
    setPreviewUrl(imgurl);
  }, [imgurl]);

  function transcate(str, length) {
    if (str.length > length) {
      return str.slice(0, length) + '...';
    }
    return str;
  }

  // useEffect(() => {
  //   if (selectedImage) {
  //     handleUploadSubmit(); // Automatically upload when an image is selected
  //   }
  // }, [selectedImage]);

  return (
    <div className="block w-2/5 p-2">
      <div className="relative flex">
        <label class="form_label_color mb-3">Image</label>
        {previewUrl && (
          <div className="flex relative ml-10">
            <img
              src={previewUrl}
              alt="Preview"
              className="w-10 h-10 rounded-lg border"
            />
            <button
              type="button"
              onClick={handleRemoveImage}
              className="absolute w-6 h-6 flex justify-center items-center -top-2 left-7 bg-red-500 text-white rounded-full p-1 shadow hover:bg-red-600"
            >
              ✕
            </button>
          </div>)}
      </div>


      {/* Hidden File Input */}
      <input
        type="file"
        accept="image/*"
        onChange={handleImageChange}
        ref={fileInputRef}
        className="hidden"
      />

      {/* Custom Upload Button and File Name */}
      <div className="flex items-center space-x-2 border_color border text-base rounded-lg w-full p-2.5 pl-0 h-12 font-[400] mt-[0px!important]">
        <button
          type="button"
          onClick={triggerFileInput}
          className="px-2 py-2 w-[130px] text-[#373737] font-medium rounded-lg focus:outline-none"
        >
          Choose File
        </button>

        <span className="text-gray-700 text-sm truncate">{fileName ? transcate(fileName, 16) : "No file chosen"}</span>

      </div>
    </div>
  );
};

export default ImageUploader;
